import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { GenericRoutingModule } from "./generic-routing.module";
import { PipeModule } from "../shared/Pipe/pipe.module";
import { PrimeNgModule } from "../prime-ng/prime-ng.module";
import { SharedModule } from "../shared/shared.module";
import { PinTableModule } from "../pin-modules/pin-table-module/pin-table.module";
import { FormsModule } from "@angular/forms";
import { VoterSearchModule } from "../voter-search/voter-search.module";
import { VisitorGenericContainerComponent } from "./visitor-generic-container/visitor-generic-container.component";
import { GenericVisitorListComponent } from "./generic-visitor-list/generic-visitor-list.component";
import { GenericVisitorInfoComponent } from "./generic-visitor-info/generic-visitor-info.component";
import { DumbModule } from "../dumb/dumb.module";
import { GenericVisitorFormComponent } from './generic-visitor-form/generic-visitor-form.component';
import { GenericForDynamicEntryComponent } from './generic-for-dynamic-entry/generic-for-dynamic-entry.component';

@NgModule({
  declarations: [
    GenericVisitorListComponent,
    GenericVisitorInfoComponent,
    VisitorGenericContainerComponent,
    GenericVisitorFormComponent,
    GenericForDynamicEntryComponent,
  ],
  imports: [
    CommonModule,
    GenericRoutingModule,
    PipeModule,
    PrimeNgModule,
    SharedModule,
    PinTableModule,
    FormsModule,
    VoterSearchModule,
    DumbModule,
  ],
  exports: [VisitorGenericContainerComponent],
})
export class GenericModule {}
